import JwtService from "@/services/jwt.service";
import { commonServices } from "@/services/common.services";

const UNIT_CODE = [];
const MODULE_ACCESS = [
  {
    unitname: "CSD",
    modules: [
      { name: "general-settings" },
      { name: "manifest" },
      { name: "user-management" }
    ]
  },
  {
    unitname: "ADM",
    modules: [{ name: "hr-settings" }, { name: "employees" }]
  },
  {
    unitname: "ITD",
    modules: [{ name: "all" }]
  },
  {
    unitname: "TRA",
    modules: [{ name: "rating" }, { name: "reporting" }, { name: "dashboard" }]
  },
  {
    unitname: "HAR",
    modules: [
      { name: "general-settings" },
      { name: "radio-log" },
      { name: "chief-pilot-log" }
    ]
  }
];

export const getModuleAccess = unit_code => {
  const modules = MODULE_ACCESS.filter(el => el.unitname === unit_code);
  return modules[0].modules;
};

export const getDepartmentCode = () => {
  // const modules = MODULE_ACCESS.filter(el => el.unitname === unit_code);
  return JwtService.getUser()["dept_code"];
};

export const getAppCode = () => {
  // const modules = MODULE_ACCESS.filter(el => el.unitname === unit_code);
  return JwtService.getUser()["app_id"];
};

export const getUserID = () => {
  return JwtService.getUser()["user_id"];
};

export const getClinicID = () => {
  return JwtService.getUser()["clinic_id"];
};

export const getPasswordExpDate = () => {
  return JwtService.getUser()["password_expiry_date"];
};

export const isFirstLOgIn = () => {
  return JwtService.getUser()["first_login"];
};

export const setAccessModules = access_module => {
  "" + access_module;
};

export const getRole = () => {
  return JwtService.getUser()["user_role"];
};

export const getUserModules = () => {
  return commonServices.getUserModules();
};

export default {
  getModuleAccess,
  setAccessModules,
  getDepartmentCode,
  getRole,
  getUserID,
  getUserModules,
  getAppCode,
  isFirstLOgIn,
  getPasswordExpDate,
  getClinicID
};
